import styles from '../css/login_new.scss';
import debounce from 'lodash.debounce';

import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);

const vm = new Vue({
    el: '#register-main',
    delimiters: ['${', '}'],  // Default delimiters ( '{{' & '}}' ) are already used by django template
    data() {
        return {
            currentStep: 1,
            isDirectorDoctor: false,
            user: {
                first_name: '',
                last_name: '',
                email: '',
            },
            facility: {
                name: '',
                nip: '',
                street: '',
                house_number: '',
                flat_number: '',
                postal_code: '',
                city: '',
                province: '',
                type: 'PL',
            },
            competitionCode: '',
            rodoAgreementUrl: '',
            marketingConsent: false,
            emailExists: false,
            competitionCodeMissing: false,
        };
    },
    computed: {
        userName() {
            return `${this.user.first_name} ${this.user.last_name}`;
        },
        facilityNameLabel() {
            if (this.facility.type === 'PL') {
                return 'Firma, nazwa albo imię i nazwisko podmiotu leczniczego';
            } else if (this.facility.type === 'PZ') {
                return 'Imię i nazwisko lekarza oraz tytuł zawodowy';
            }
            return '';
        },
    },
    mounted() {
        // If registration has prefilled contact in link inputs' value attribute will be overwritten by v-model
        this.user.first_name = this.$refs.userFirstName.getAttribute('value') || '';
        this.user.last_name = this.$refs.userLastName.getAttribute('value') || '';
        // Hides loader and shows form only after Vue is initialized and ready to go
        this.$refs.loader.style.display = 'none';
        this.$refs.formContainer.style.display = 'block';
        $(this.$refs.emailExistSign).popover({
            container: 'body',
            placement: 'top',
            content: 'Użytkownik o takim adresie email jest już zarejestrowany!',
            trigger: 'hover',
        });
        $(this.$refs.competitionCodeMissingSign).popover({
            container: 'body',
            placement: 'top',
            content: 'Podany kod opiekuna nie istnieje!',
            trigger: 'hover',
        });
    },
    methods: {
        back() {
            this.currentStep = Math.max(this.currentStep - 1, 1);
        },
        getCityFromPostal(code) {
            $.ajax({
                url: '/secure/get_city_by_postal_code/',
                method: 'GET',
                data: { code },
            }).then((data) => {
                if (data.found_cities === 1) {
                    this.facility.city = data.city;
                    this.facility.province = data.province;
                }
            });
        },
        generateRodoUrl() {
            if(!window.Cypress) {
                this.rodoAgreementUrl = '/secure/personal_data_process_agreement_pdf/' +
                    `?first_name=${this.user.first_name}` +
                    `&last_name=${this.user.last_name}` +
                    `&email=${this.user.email}` +
                    `&facility_name=${this.facility.name}` +
                    `&nip=${this.facility.nip}` +
                    `&street=${this.facility.street}` +
                    `&house_number=${this.facility.house_number}` +
                    `&flat_number=${this.facility.flat_number}` +
                    `&city=${this.facility.city}`;
            }
            else {
//              this url is used only while runing e2e tests to prevent popup window with download.pdf
                this.rodoAgreementUrl = 'static/docs/regulamin.pdf'
            }
        },
        step1Proceed() {
            if ($(this.$refs.userDataForm).parsley({excluded: '[disabled]'}).validate() === true) {
                this.generateRodoUrl();
                this.currentStep = 2;
            }
        },
        step2Proceed() {
            if ($(this.$refs.termsAcceptForm).parsley().validate() === true) {
                this.currentStep = 3;
            }
        },
        step3Proceed() {
            if ($(this.$refs.rodoAcceptForm).parsley().validate() === true) {
                this.$refs.userDataForm.submit();
            }
        },
        validateCompetitionCode: debounce(function(compCode) {
            if (compCode) {
                $.get(
                    '/secure/competition_codes/competition_code_is_active/',
                    {competition_code: compCode},
                ).then((data) => {
                    this.competitionCodeMissing = !data.result;
                });
            } else {
                this.competitionCodeMissing = false;
            }
        }, 500),
    },
    watch: {
        userName(username) {
            if (this.facility.name === '' || this.facility.name.startsWith('Praktyka lecznicza - ')) {
                this.facility.name = `Praktyka lecznicza - ${username}`;
                this.$nextTick(() => {
                    $(this.$refs.facilityName).parsley().validate(); // Remove red bg from name
                });
            }
        },
        isDirectorDoctor(val) {
            if (val === false) {
                this.$refs.doctorPwz.value = '';
                $(this.$refs.doctorPwz).parsley().reset();
            }
        },
        'facility.postal_code'(code) {
            if (code.match(/[0-9]{2}-[0-9]{3}/)) {
                this.getCityFromPostal(code);
            }
        },
        'user.email'(mail) {
            if (mail.match(/^.+@.*\.[a-zA-Z]{2,}$/)) {
                $.get('/secure/email_user_exists/', {email: mail}).then((data) => {
                    this.emailExists = data.result;
                });
            } else {
                this.emailExists = false;
            }
        },
        competitionCode(compCode) {
            this.validateCompetitionCode(compCode);
        },
    },
});



// WEBPACK FOOTER //
// ./src/register.js